import { useContext } from "react";
import { MenuItem, Select, Typography } from "@mui/material";
import { FormControl } from "@material-ui/core";
import { classes } from "../classes";
import DropdownIcon from "../../DropdownIcon";

export default function Late({ context }) {
    
    const {
        late, setLate,
    } = useContext(context);

    return (
        <>
            <Typography style={classes.labelInput}>
                Tempo de Previsão:
            </Typography>
            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    onChange={(e) => setLate(e.target.value)}
                    value={late}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="true">Atendimento atrasado</MenuItem>
                    <MenuItem value="false">Atendimento em dia</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}